import { MOM_CATALOG_PRODUCTS } from '../data/products';
import { Header } from './organisms/Header';
import { CatalogTemplate } from './templates/CatalogTemplate';
import { handlePrint, printStyles } from '../utils/exportPdf';
import { Box } from '@mui/material';

/**
 * Container Component: Implementa la lógica de negocio y ensambla la Landing.
 */
export const CatalogContainer = () => {
  return (
    <Box>
      {printStyles}
      <Header onExport={handlePrint} />
      <CatalogTemplate />
    </Box>
  );
};
